import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Benefits from "./components/Benefits";
import SeoText from "./components/SeoText";
import Neighborhoods from "./components/Neighborhoods";
import CtaFinal from "./components/CtaFinal";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <main>
      <Navbar />
      <Hero />
      <Benefits />
      <SeoText />
      <Neighborhoods />
      <CtaFinal />
      <Footer />
    </main>
  );
}
